import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { useFormatCurrency } from '@/shared/lib'

type Props = Pick<TRoomDetail, 'usingFee' | 'mgmtFee' | 'minimumContractWeeks'>

export const MobileContractFee = ({
  usingFee,
  mgmtFee,
  minimumContractWeeks,
}: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  return (
    <div className="space-y-0.5">
      <dl className="typo-label1 flex gap-1 font-normal">
        <dt className="text-gray-500">{t('room_detail.minimum_contract')}</dt>
        <dd className="text-gray-900">
          {t('common.week', { week: minimumContractWeeks })}
        </dd>
      </dl>
      <div className="flex flex-col gap-x-5 gap-y-0.5 md:flex-row md:items-center">
        <div className="typo-body1 flex items-center gap-1.5">
          <p className="typo-headline1 flex items-center gap-0.5 font-bold text-black">
            {formatCurrency(usingFee + mgmtFee, {
              unit: chunks => (
                <span className="typo-body2 font-medium">{chunks}</span>
              ),
            })}
          </p>
          <span className="font-light text-gray-200">/</span>
          <span className="font-bold text-purple-500">
            {t('common.week_unit')}
          </span>
        </div>
        <dl className="flex gap-3">
          <div className="typo-label1 flex gap-1 font-normal">
            <dt className="text-gray-500">{t('common.rent')}</dt>
            <dd className="text-gray-900">{formatCurrency(usingFee)}</dd>
          </div>
          <div className="typo-label1 flex gap-1 font-normal">
            <dt className="text-gray-500">{t('common.utility_fee')}</dt>
            <dd className="text-gray-900">{formatCurrency(mgmtFee)}</dd>
          </div>
        </dl>
      </div>
    </div>
  )
}
